import React, { useContext, useRef, useEffect } from "react";
import { Icon } from "@iconify/react";

import { useLanguageVisibility } from "../../../language/hooks/use-language-visibility";
import { store } from "../../../Store";
import { DropdownLang } from "../../../language/dropdown-lang";
import { useLanguage } from "../../../../hooks/use-language";
import { useTranslationsById } from "../../../../hooks/use-translations-by-id";
import { Drop } from "./drop";

/**
 * Rederiza el boton de lenguaje en el Header publico
 * @returns {React.Component}
 */
export const PublicLangButton = () => {
    const languageVisibility = useLanguageVisibility();
    const globalState = useContext(store);
    const isAuth = globalState?.state?.sesionActiva === "SI";
    const language = useLanguage();
    const texts = useTranslationsById({ mainSectionName: "header", language: language });

    const langRefa = useRef(null);

    const handleVisibility = () => {
        if (languageVisibility.isVisible) {
            languageVisibility.hide();
        }
        else {
            languageVisibility.show();
        }
    }

    /**Función que permite cerrar el dropdown dando click fuera de él*/
      useEffect(() => {
        let handler = (e) => {
          if ( !langRefa.current.contains(e.target)) {
            languageVisibility.hide();
          }
        }
        document.addEventListener("mousedown", handler);
    
        return () => {
          document.removeEventListener("mousedown", handler)
        }
      }, [])

    return (
        <div ref={langRefa}>
            <button
                className={`${
                    languageVisibility.isVisible ? 
                      "relative lang icon-button icon-responsive ml-1 activeMode" 
                      : 
                      "relative lang icon-button icon-responsive ml-1"
                } focusable-red`}
                onClick={() => { handleVisibility(); }}
                aria-label={texts?.getText({ id: "button_languages_description", defaultText: "Abrir la lista desplegable de idiomas seleccionables"}) }
            >
                <Icon icon="tabler:language" width={25} height={25} className="ml-0"/>
            </button>

            <Drop  visibility={handleVisibility}/>
        </div>

    )
}